module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-header",
    class: {
      stories90d: _vm.is90d
    }
  }, [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": "/admin/domains"
    }
  }, [(!_vm.is90d) ? _c('span', {
    staticClass: "logo-mini"
  }, [_c('b', [_c('img', {
    attrs: {
      "src": "/static/img/sm-logo.png",
      "alt": "User Image"
    }
  })])]) : _c('span', {
    staticClass: "logo-mini"
  }, [_c('b', [_c('img', {
    attrs: {
      "src": "/static/img/rsz_logo_black_fav.png",
      "alt": "User Image"
    }
  })])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.is90d),
      expression: "!is90d"
    }],
    staticClass: "logo-lg"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/bg-logo.png",
      "alt": "User Image"
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is90d),
      expression: "is90d"
    }],
    staticClass: "logo-lg"
  }, [_c('img', {
    staticClass: "logo-90d",
    attrs: {
      "src": "/static/img/rsz_Logo_Black_Verticle.png",
      "alt": "User Image"
    }
  })])]), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pull-left-search",
    on: {
      "click": function($event) {
        return _vm.toogleSearch()
      }
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.domain.name),
      expression: "domain.name"
    }],
    staticClass: "domain-bucket-details"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "atdIcon"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-globe fa-w-16 fa-2x",
    attrs: {
      "width": "12px",
      "height": "12px",
      "aria-hidden": "true",
      "data-prefix": "fas",
      "data-icon": "globe",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M364.215 192h131.43c5.439 20.419 8.354 41.868 8.354 64s-2.915 43.581-8.354 64h-131.43c5.154-43.049 4.939-86.746 0-128zM185.214 352c10.678 53.68 33.173 112.514 70.125 151.992.221.001.44.008.661.008s.44-.008.661-.008c37.012-39.543 59.467-98.414 70.125-151.992H185.214zm174.13-192h125.385C452.802 84.024 384.128 27.305 300.95 12.075c30.238 43.12 48.821 96.332 58.394 147.925zm-27.35 32H180.006c-5.339 41.914-5.345 86.037 0 128h151.989c5.339-41.915 5.345-86.037-.001-128zM152.656 352H27.271c31.926 75.976 100.6 132.695 183.778 147.925-30.246-43.136-48.823-96.35-58.393-147.925zm206.688 0c-9.575 51.605-28.163 104.814-58.394 147.925 83.178-15.23 151.852-71.949 183.778-147.925H359.344zm-32.558-192c-10.678-53.68-33.174-112.514-70.125-151.992-.221 0-.44-.008-.661-.008s-.44.008-.661.008C218.327 47.551 195.872 106.422 185.214 160h141.572zM16.355 192C10.915 212.419 8 233.868 8 256s2.915 43.581 8.355 64h131.43c-4.939-41.254-5.154-84.951 0-128H16.355zm136.301-32c9.575-51.602 28.161-104.81 58.394-147.925C127.872 27.305 59.198 84.024 27.271 160h125.385z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_c('router-link', {
    attrs: {
      "to": '/admin/publisher/' + _vm.uuid + '/domain/edit/' + _vm.domain.id
    }
  }, [_vm._v(_vm._s(_vm.domain.name) + " ")])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bucket.length > 0),
      expression: "bucket.length > 0"
    }],
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "atdIcon"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-bitbucket fa-w-16 fa-2x",
    attrs: {
      "width": "12px",
      "height": "12px",
      "aria-hidden": "true",
      "data-prefix": "fab",
      "data-icon": "bitbucket",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M23.1 32C14.2 31.9 7 38.9 6.9 47.8c0 .9.1 1.8.2 2.8L74.9 462c1.7 10.4 10.7 18 21.2 18.1h325.1c7.9.1 14.7-5.6 16-13.4l67.8-416c1.4-8.7-4.5-16.9-13.2-18.3-.9-.1-1.8-.2-2.8-.2L23.1 32zm285.3 297.3H204.6l-28.1-146.8h157l-25.1 146.8z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_c('el-dropdown', {
    on: {
      "command": _vm.bucketChange
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_vm._v("\n                            " + _vm._s(_vm.selectedBucketDetails.name) + " "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l((_vm.bucket), function(b) {
    return _c('el-dropdown-item', {
      key: b.id,
      attrs: {
        "command": ("" + (b.id))
      }
    }, [_vm._v(_vm._s(b.name))])
  }), 1)], 1), _vm._v(" "), _c('a', {
    staticClass: "upload",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.createJs()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--right"
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', [_c('el-dropdown', {
    staticClass: "header-dropdown-devin",
    attrs: {
      "trigger": "click"
    },
    on: {
      "visible-change": _vm.notifDropdownToggle
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('el-badge', {
    staticClass: "item"
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "ti-bell"
  })])], 1), _vm._v(" "), _c('sup', {
    ref: "notifDot",
    staticClass: "el-badge__content is-fixed is-dot Blink"
  })], 1), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('ul', {
    staticClass: "dropdown-menu-devin"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("Latest notifications")]), _vm._v(" "), _c('li', [_c('ul', {
    staticClass: "menu"
  }, [(_vm.allNotifications.length == 0) ? _c('h5', {
    staticStyle: {
      "text-align": "center",
      "color": "#d75252"
    }
  }, [_vm._v("No new notifications")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.allNotifications), function(notif) {
    return _c('li', {
      key: notif.id
    }, [_c('i', {
      staticClass: "ti-user"
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": "#"
      }
    }, [(notif.pub_uid && notif.domain_id) ? _c('div', [_c('router-link', {
      attrs: {
        "to": {
          path: ("/admin/publisher/" + (notif.pub_uid) + "/domain/edit/" + (notif.domain_id) + "/")
        }
      }
    }, [_c('h3', {
      staticClass: "notif-message"
    }, [_vm._v(_vm._s(notif.message)), _c('span', {
      staticClass: "text-yellow fontello-record"
    }, [(notif.type == 'started') ? _c('i', {
      staticClass: "el-icon-loading"
    }) : _vm._e(), _vm._v(" "), (notif.type == 'complete') ? _c('i', {
      staticClass: "el-icon-success"
    }) : _vm._e(), _vm._v(" "), (notif.type == 'error') ? _c('i', {
      staticClass: "el-icon-error",
      staticStyle: {
        "color": "red !important"
      }
    }) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "fa fa-external-link",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])], 1) : _c('div', [_c('h3', {
      staticClass: "notif-message"
    }, [_vm._v(_vm._s(notif.message)), _c('span', {
      staticClass: "text-yellow fontello-record"
    }, [(notif.type == 'started') ? _c('i', {
      staticClass: "el-icon-loading"
    }) : _vm._e(), _vm._v(" "), (notif.type == 'complete') ? _c('i', {
      staticClass: "el-icon-success"
    }) : _vm._e(), _vm._v(" "), (notif.type == 'error') ? _c('i', {
      staticClass: "el-icon-error",
      staticStyle: {
        "color": "red !important"
      }
    }) : _vm._e()])])]), _vm._v(" "), _c('p', [_vm._v("at " + _vm._s(_vm._f("moment")(notif.timestamp, "'MMM Do YYYY, h:mm:ss a")))])])])
  })], 2)])])])], 1)], 1), _vm._v(" "), _c('li', [_c('el-dropdown', {
    staticClass: "header-dropdown-devin",
    attrs: {
      "trigger": "click"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('el-button', {
    attrs: {
      "data-toggle": "control-sidebar",
      "type": "text",
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "ti-menu-alt"
  })])], 1)])], 1)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.search.showSearch),
      expression: "search.showSearch"
    }],
    staticClass: "search-overflow",
    class: {
      appear: _vm.search.showSearch
    }
  }, [_c('div', {
    staticClass: "close-container",
    on: {
      "click": function($event) {
        return _vm.toogleSearch()
      }
    }
  }, [_c('span', {
    staticClass: "cclose"
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    staticClass: "close-text"
  }, [_vm._v("Esc")])]), _vm._v(" "), _c('div', {
    staticClass: "search-container"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "search pull-left",
    class: {
      searching: _vm.search.networkcall
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.query),
      expression: "search.query"
    }],
    ref: "search",
    staticClass: "devin-search",
    attrs: {
      "type": "search",
      "placeholder": "Search..."
    },
    domProps: {
      "value": (_vm.search.query)
    },
    on: {
      "keyup": _vm.searchDomPub,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "query", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "create-button pull-left"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: "/admin/create-domain/"
      }
    }
  }, [_c('a', {
    staticClass: "el-button el-button--success",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.redirect('/admin/create-domain/')
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus el-icon-left"
  }), _vm._v("\n                            Domain\n                        ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "search-result"
  }, [_c('div', {
    staticClass: "search-list"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("Domain list")]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%",
      "border-spacing": "0"
    },
    attrs: {
      "data": _vm.search.domains
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "text-center"
        }, [_c('img', {
          staticClass: "round",
          attrs: {
            "width": "30",
            "height": "30",
            "avatar": ("" + (scope.row.name))
          }
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "300",
      "label": "",
      "prop": "name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "to": {
              path: ("/admin/publisher/" + (props.row.publisher.uuid) + "/domain/edit/" + (props.row.id) + "/")
            }
          }
        }, [_c('a', {
          attrs: {
            "href": "javascript:void(0);"
          },
          on: {
            "click": function($event) {
              return _vm.redirect('/admin/publisher/' + props.row.publisher.uuid + '/domain/edit/' + props.row.id + '/')
            }
          }
        }, [_c('span', {
          staticClass: "domain-name"
        }, [_vm._v(_vm._s(("" + (props.row.name))))]), _vm._v(" "), _c('span', {
          staticClass: "publisher-name"
        }, [_vm._v(_vm._s(("" + (props.row.publisher.name))))]), _vm._v(" "), (props.row.dfp_network != null) ? _c('span', {
          staticClass: "dfp-name"
        }, [_vm._v(_vm._s(("" + (props.row.dfp_network.display_name))) + " DFP")]) : _vm._e()])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Reports",
      "prop": "Reports",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-tooltip', {
          attrs: {
            "content": "Reports",
            "placement": "bottom"
          }
        }, [_c('router-link', {
          attrs: {
            "to": {
              path: ("/admin/publisher/" + (props.row.publisher.id) + "/ReportsRevenue/" + (props.row.id) + "/")
            }
          }
        }, [_c('a', {
          attrs: {
            "href": "javascript:void(0);"
          },
          on: {
            "click": function($event) {
              return _vm.redirect('/admin/publisher/' + props.row.publisher.id + '/ReportsRevenue/' + props.row.id)
            }
          }
        }, [_c('el-button', {
          staticClass: "notes-box",
          attrs: {
            "type": "text",
            "size": "small"
          }
        }, [_c('span', [_c('i', {
          staticClass: "fa fa-line-chart",
          attrs: {
            "aria-hidden": "true"
          }
        })])])], 1)])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-dropdown', {
          attrs: {
            "trigger": "click"
          }
        }, [_c('span', {
          staticClass: "el-dropdown-link"
        }, [_c('el-badge', {
          staticClass: "item",
          attrs: {
            "value": 0,
            "max": 10
          }
        }, [_c('el-button', {
          directives: [{
            name: "clipboard",
            rawName: "v-clipboard:copy",
            value: (props.row.site_tag),
            expression: "props.row.site_tag",
            arg: "copy"
          }, {
            name: "clipboard",
            rawName: "v-clipboard:success",
            value: (_vm.onCopy),
            expression: "onCopy",
            arg: "success"
          }, {
            name: "clipboard",
            rawName: "v-clipboard:error",
            value: (_vm.onError),
            expression: "onError",
            arg: "error"
          }],
          staticClass: "notes-box",
          attrs: {
            "type": "text",
            "size": "small"
          }
        }, [_c('span', [_c('svg', {
          staticClass: "svg-inline--fa fa-copy fa-w-14 fa-2x",
          attrs: {
            "width": "17px",
            "height": "17px",
            "aria-hidden": "true",
            "data-prefix": "fal",
            "data-icon": "copy",
            "role": "img",
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 448 512"
          }
        }, [_c('path', {
          attrs: {
            "fill": "currentColor",
            "d": "M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM352 32.491a15.88 15.88 0 0 1 7.431 4.195l51.882 51.883A15.885 15.885 0 0 1 415.508 96H352V32.491zM288 464c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V144c0-8.822 7.178-16 16-16h80v240c0 26.51 21.49 48 48 48h112v48zm128-96c0 8.822-7.178 16-16 16H176c-8.822 0-16-7.178-16-16V48c0-8.822 7.178-16 16-16h144v72c0 13.2 10.8 24 24 24h72v240z"
          }
        })])])])], 1)], 1), _vm._v(" "), _c('el-dropdown-menu', {
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('ul', {
          staticClass: "dropdown-menu-devin",
          staticStyle: {
            "max-width": "700px !important"
          }
        }, [_c('li', {
          staticClass: "header",
          staticStyle: {
            "margin": "5px",
            "font-size": "12px"
          }
        }, [_vm._v("\n                                                " + _vm._s((props.row.site_tag) ? props.row.site_tag : 'No Script Present.') + "\n                                            ")]), _vm._v(" "), _c('li', {
          staticClass: "text-danger",
          staticStyle: {
            "margin-left": "20px",
            "font-size": "10px"
          }
        }, [_c('b', [_vm._v("copied!")])])])])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "to": {
              path: ("/admin/domains/notes/" + (props.row.id))
            }
          }
        }, [_c('a', {
          attrs: {
            "href": "javascript:void(0);"
          },
          on: {
            "click": function($event) {
              return _vm.redirect('/admin/domains/notes/' + props.row.id)
            }
          }
        }, [_c('el-button', {
          staticClass: "notes-box",
          attrs: {
            "type": "text",
            "size": "small"
          }
        }, [_c('span', [_c('svg', {
          staticClass: "svg-inline--fa fa-pen-square fa-w-14 fa-2x",
          attrs: {
            "width": "17px",
            "height": "17px",
            "aria-hidden": "true",
            "data-prefix": "far",
            "data-icon": "pen-square",
            "role": "img",
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 448 512"
          }
        }, [_c('path', {
          attrs: {
            "fill": "currentColor",
            "d": "M246.6 177.9l55.5 55.5c2.3 2.3 2.3 6.1 0 8.5L166.4 377.6l-57.1 6.3c-7.6.8-14.1-5.6-13.3-13.3l6.3-57.1L238 177.8c2.4-2.2 6.2-2.2 8.6.1zm98.4-12.8L314.9 135c-9.4-9.4-24.6-9.4-33.9 0l-23.1 23.1c-2.3 2.3-2.3 6.1 0 8.5l55.5 55.5c2.3 2.3 6.1 2.3 8.5 0L345 199c9.3-9.3 9.3-24.5 0-33.9zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
          }
        })])])])], 1)])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('div', {
          staticClass: "buckets"
        }, [_c('ul', {
          staticClass: "bucket-list clearfix",
          style: ({
            width: (122 * ((props.row.buckets && props.row.buckets.length) > 3 ? props.row.buckets.length : 4)) + 'px'
          })
        }, _vm._l((props.row.buckets), function(bucket) {
          return _c('li', {
            staticClass: "shadowBox"
          }, [_c('router-link', {
            attrs: {
              "to": {
                path: ("/admin/publisher/" + (props.row.publisher.uuid) + "/domain/" + (props.row.id) + "/buckets/" + (bucket.id) + "/")
              }
            }
          }, [_c('a', {
            attrs: {
              "href": "javascript:void(0);"
            },
            on: {
              "click": function($event) {
                return _vm.redirect('/admin/publisher/' + props.row.publisher.uuid + '/domain/' + props.row.id + '/buckets/' + bucket.id + '/')
              }
            }
          }, [_c('span', {}, [_c('svg', {
            staticClass: "svg-inline--fa fa-bitbucket fa-w-16 fa-3x",
            attrs: {
              "aria-hidden": "true",
              "width": "12",
              "height": "12",
              "data-prefix": "fab",
              "data-icon": "bitbucket",
              "role": "img",
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 512 512"
            }
          }, [_c('path', {
            attrs: {
              "fill": "currentColor",
              "d": "M23.1 32C14.2 31.9 7 38.9 6.9 47.8c0 .9.1 1.8.2 2.8L74.9 462c1.7 10.4 10.7 18 21.2 18.1h325.1c7.9.1 14.7-5.6 16-13.4l67.8-416c1.4-8.7-4.5-16.9-13.2-18.3-.9-.1-1.8-.2-2.8-.2L23.1 32zm285.3 297.3H204.6l-28.1-146.8h157l-25.1 146.8z"
            }
          })])]), _vm._v(" "), _c('span', {}, [_vm._v(" " + _vm._s(("" + (bucket.name))))])])])], 1)
        }), 0)])]
      }
    }])
  })], 1)], 1)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "offcanvas",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "relative",
    attrs: {
      "id": "demo-2"
    }
  }, [_c('input', {
    staticClass: "devin-search",
    attrs: {
      "type": "search"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fed2e79","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Header.vue
// module id = 692
// module chunks = 2